import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";

const useInactivateManagementCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => AdminManagementCompaniesService.inactivateManagementCompany(id),
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao inativar gestora. Tente novamente mais tarde."), {
        toastId: "inactivate_management_company_error",
      });
    },
    onSuccess: (_data, id) => {
      toast.success("Gestora inativada com sucesso!");
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANIES] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANY(id)], exact: true });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_TOTALIZERS] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_OWNERS] });
    },
  });
};

export default useInactivateManagementCompany;
